import Vue from 'vue'
import Router from 'vue-router'
const Home = r => require.ensure([],() => r(require('../components/Home')),'Home')
const LottoDetail = r => require.ensure([],() => r(require('../components/LottoDetail')),'LottoDetail')
const News = r => require.ensure([],() => r(require('../components/News')),'News')
const LongQueue = r => require.ensure([],() => r(require('../components/LongQueue')),'LongQueue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Home'
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/LottoDetail',
      name: 'LottoDetail',
      component: LottoDetail,
    },
    {
      path: '/News',
      name: 'News',
      component: News,
    },
    {
      path: '/LongQueue',
      name: 'LongQueue',
      component: LongQueue,
    },
    {
      path: '*',
      redirect: '/Home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js